export default [
  {
    path: "/altimaMusic", // 无视频
    name: "altimaMusic",
    meta: {
      title: "咪咕音乐天籁VIP",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/miguTl/altimaMusic")
  },
  {
    path: "/bjvip", // 无视频
    name: "bjvip",
    meta: {
      title: "咪咕音乐白金会员B版",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/miguTl/bjvip")
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/miguTl.js